import script from "./ShortLiveCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortLiveCard.vue?vue&type=script&setup=true&lang=js"

import "./ShortLiveCard.vue?vue&type=style&index=0&id=2c3981b3&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3981b3"]])

export default __exports__